import React from 'react';
import './index.css'

const RoutableSelects = (props) => {
    const { buttonGroupData, swotid, history } = props
    return (
        <select 
        className="drop-down form-control"
        style={{width: 100, background: '#fff'}}
        onChange={(e) =>  {
                history.push(e.target.value)
            }
        }
        >
        {
            buttonGroupData.map((val, key) => {
                return(
                    <option key={key} selected={swotid == val.id ? true : false} value={val.link} >{val.name}</option>
                )
            })
        }
        </select> 
    );
} 

export default RoutableSelects


// WEBPACK FOOTER //
// ./src/_components/common/RoutableSelects/index.js